import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Bars.scss";
import ToggleButton from "./SideDrawer/ToggleButton";
import SideDrawer from "./SideDrawer/SideDrawer";
import MiniCart from "../MiniCart/MiniCart";
import { useCart } from "../../shared/CartContext";

export default function Bars() {
  const [sideDrawerOpen, setSideDrawerOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const { totalItems } = useCart();

  const drawerToggleClickHandler = () => {
    setSideDrawerOpen(!sideDrawerOpen);
  };

  return (
    <>
      <div className="bars">
        {/* LEFT: logo */}
        <div className="bars__left">
          <NavLink to="/" className="bars__logo">
            IKONE<b>.RS</b>
          </NavLink>
        </div>

        {/* CENTER: navigation links */}
        <nav className="bars__categories">
          <NavLink to="/" end className="bars__cat-link">Početna</NavLink>
          <NavLink to="/prodavnica" className="bars__cat-link">Ikone</NavLink>
          <NavLink to="/prodavnica" className="bars__cat-link">Prodavnica</NavLink>
          <NavLink to="/kontakt" className="bars__cat-link">Kontakt</NavLink>
        </nav>

        {/* RIGHT: search + cart + hamburger */}
        <div className="bars__right">
          <button className="bars__icon-btn" aria-label="Pretraga">
            <i className="fa-solid fa-magnifying-glass" />
          </button>
          <button className="bars__icon-btn bars__icon-btn--cart" aria-label="Korpa" onClick={() => setCartOpen(true)}>
            <i className="fa-solid fa-bag-shopping" />
            {totalItems > 0 && <span className="bars__cart-badge">{totalItems}</span>}
          </button>
          <ToggleButton clicked={drawerToggleClickHandler} />
        </div>
      </div>

      {sideDrawerOpen && (
        <div className="bars__backdrop" onClick={drawerToggleClickHandler} />
      )}
      <SideDrawer show={sideDrawerOpen} clicked={drawerToggleClickHandler} />
      <MiniCart open={cartOpen} onClose={() => setCartOpen(false)} />
    </>
  );
}
